import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/display.css'
import 'element-ui/lib/theme-chalk/index.css';
import './fonts/fonts.css'
import './fonts/font-awesome.min.css'
import animated from 'animate.css'
import i18n from './plugins/i18n.js'
import {getLang, getProductstypeUrl, statistics} from './util/lang.js'
import Scrollbar from 'smooth-scrollbar';
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
  observer: true
})

router.beforeEach((to, from, next) => {
  // ...
  if(to.name!==from.name){
    Scrollbar.destroyAll()
  }
  
  next()
})


// lang
// 优先级: localStorage > 浏览器 > default: en
const lang = window.localStorage.getItem('lang') || getLang()
store.commit('setLang', lang)
i18n.locale = lang

// 产品分类 异步 promise
const url = getProductstypeUrl(lang)
axios.get(url).then(res => {
  // window.console.log(res.data.length)
  store.commit('setLangProducttype', {
    lang,
    productstype: res.data
  })
})




//转成axios请求
const url_sta = statistics()
axios.get(url_sta).then(res => {
    // window.console.log(res.data.length)
})
// newType
const newType = require('./util/NewTypes.json')
store.commit('setLangNewtype', newType)

Vue.prototype.$$axios = axios

Vue.config.productionTip = false

Vue.use(ElementUI);
Vue.use(animated)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
